/**
 * @generated SignedSource<<0963aa6a6f117e14059957448602afc0>>
 * @relayHash 738fec33aa30e8c291d2e94e0f13354e
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 738fec33aa30e8c291d2e94e0f13354e

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type de_BetterDocExchangeOperation = "CONFIRM_RECOMMENDATION_RESULTS" | "CONFIRM_SELECTED_MEDICS" | "CREATE_RECOMMENDATION" | "GET_RECOMMENDATION" | "LIST_RECOMMENDATIONS" | "LIST_RECOMMENDED_RECOMMENDATIONS" | "LIST_SELECTED_RECOMMENDATIONS" | "SEARCH_CARE_PROVIDERS" | "SELECT_MEDIC" | "SEND_REFERRAL_SLIP" | "SIMULATE_PATIENT_SELECTION" | "SIMULATE_RESEARCH" | "SIMULATE_SECOND_OPINION_VISIT_CONFIRMATION";
export type de_BetterDocExchangeFilterInput = {
  isFailedOnly?: boolean | null;
  isTestCase?: boolean | null;
  operation?: de_BetterDocExchangeOperation | null;
  startedFrom?: string | null;
  startedTo?: string | null;
};
export type BetterDocExchangesPaginationQuery$variables = {
  after?: string | null;
  filter?: de_BetterDocExchangeFilterInput | null;
  first?: number | null;
};
export type BetterDocExchangesPaginationQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"betterDocExchangesQueryListFragment">;
};
export type BetterDocExchangesPaginationQuery = {
  response: BetterDocExchangesPaginationQuery$data;
  variables: BetterDocExchangesPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BetterDocExchangesPaginationQuery",
    "selections": [
      {
        "args": (v1/*:: as any*/),
        "kind": "FragmentSpread",
        "name": "betterDocExchangesQueryListFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "BetterDocExchangesPaginationQuery",
    "selections": [
      {
        "alias": "exchanges",
        "args": (v1/*:: as any*/),
        "concreteType": "de_BetterDocExchangeSummaryConnection",
        "kind": "LinkedField",
        "name": "de_betterDocExchanges",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "de_BetterDocExchangeSummaryEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "de_BetterDocExchangeSummary",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "exchangeId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "operation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "actor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "httpMethod",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "requestUri",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isTestCase",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasUnexpectedResponse",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "responseStatusCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "durationMilliseconds",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "startedAt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "outcome",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "failureKind",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "exchanges",
        "args": (v1/*:: as any*/),
        "filters": [
          "filter"
        ],
        "handle": "connection",
        "key": "BetterDocExchangesFragment_exchanges",
        "kind": "LinkedHandle",
        "name": "de_betterDocExchanges"
      }
    ]
  },
  "params": {
    "id": "738fec33aa30e8c291d2e94e0f13354e",
    "metadata": {},
    "name": "BetterDocExchangesPaginationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9a022233784e7ae3d1c1ffaabc2be3b5";

export default node;
